import { Routes, Route, Navigate } from "react-router-dom";
import HomePage from "../../pages/Home/HomePage";
import LoginPage from "../../pages/Login/LoginPage";
import SignupPage from "../../pages/Signup/SignupPage";
import ForgotPasswordEmail from "../../pages/ForgetResetPassword/pages/ForgotPasswordEmail";
import ResetPassword from "../../pages/ForgetResetPassword/pages/ResetPassword";
import AuthGuard from "../context/AuthGuard";

import analyzeRoutes from "../../features/analyze/analyze.routes";
import briefRoutes from "../../features/brief/brief.routes";
import generateRoutes from "../../features/generate/generate.routes";
import audienceRoutes from "../../features/audience/audience.routes";
import activateRoutes from "../../features/activate/activate.routes";
import projectRoutes from "../../features/project/project.route";
import profileRoutes from "../../pages/Profile/profile.route";
import usersRoutes from "../../pages/Users/users.route";
import teamRoutes from "../../pages/Team/team.route";
import roleRoutes from "../../pages/Role/role.route";
import jobTitleRoutes from "../../pages/JobTitle/jobTitle.route";
import moduleRoutes from "../../features/modules/module.route";
import permissionRoutes from "../../features/permissions/permissions.route";

export default function AppRoutes() {
  const dynamicRoutes = [
    ...analyzeRoutes,
    ...briefRoutes,
    ...generateRoutes,
    ...audienceRoutes,
    ...activateRoutes,
    ...projectRoutes,
    ...profileRoutes,
    ...usersRoutes,
    ...teamRoutes,
    ...roleRoutes,
    ...jobTitleRoutes,
    ...moduleRoutes,
    ...permissionRoutes
  ];

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordEmail />} />
      <Route path="/reset-password" element={<ResetPassword />} />

      <Route
        path="/"
        element={
          <AuthGuard>
            <HomePage />
          </AuthGuard>
        }
      />

      {dynamicRoutes.map((route, i) => (
        <Route
          key={i}
          path={route.path}
          element={<AuthGuard>{route.element}</AuthGuard>}
        />
      ))}

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}